//import { helpers } from '../helpers.js';

var modal = {
  options: {
    // global options
  },

  selectors: {
    // global selectors
  },

  init: function () {
    const self = this;

    self.bindEvents();
  },

  bindEvents: function () {
    const self = this;

    jQuery("[data-modal-id]").each(function (index) {
      const id_modal = jQuery(this).data("modal-id");

      jQuery(this).on("click", function (event) {
        event.preventDefault();
        self.openModal(id_modal);
      });

      jQuery("#" + id_modal).on("mousedown", function (event) {
        if (event.target.className === "modal__outer") {
          self.closeModal(id_modal);
        }
      });
    });
  },

  openModal: function (id_modal) {
    const self = this;

    const modal = jQuery("#" + id_modal);
    const window_width_before_disable = jQuery(window).width();

    jQuery("html").addClass("disable-scroll");
    modal.addClass("open-prepare");

    setTimeout(() => {
      modal.addClass("open");
    }, 10);

    //fix scrollbar
    const scrollbar_width = jQuery(window).width() - window_width_before_disable;
    jQuery("body").css("margin-right", scrollbar_width + "px");

    //bind close button event
    modal.find(".close").one("click", function (event) {
      event.preventDefault();
      self.closeModal(id_modal);
    });
  },

  closeModal: function (id_modal) {
    const self = this;

    const modal = jQuery("#" + id_modal);

    modal.removeClass("open");

    modal[0].addEventListener("transitionend", () => {
      modal.removeClass("open-prepare");
      jQuery("html").removeClass("disable-scroll");
      jQuery("body").css("margin-right", "");
    }, { once: true });
  }
}

// Export
export { modal };